import { PublicKey } from '@solana/web3.js';

const GLOBAL_CONFIG_SIZE = 118;
const ANCHOR_DISCRIMINATOR_SIZE = 8;

function createDataView(bytes, offset, length) {
  return new DataView(bytes.buffer, bytes.byteOffset + offset, length);
}

function readPubkey(bytes, offset) {
  return new PublicKey(bytes.slice(offset, offset + 32)).toBase58();
}

function readU16(bytes, offset) {
  return createDataView(bytes, offset, 2).getUint16(0, true);
}

function readU64(bytes, offset) {
  return createDataView(bytes, offset, 8).getBigUint64(0, true).toString();
}

function readI64(bytes, offset) {
  return createDataView(bytes, offset, 8).getBigInt64(0, true).toString();
}

function readBool(bytes, offset) {
  return bytes[offset] !== 0;
}

function readU8(bytes, offset) {
  return bytes[offset];
}

export function decodeGlobalConfigAccount(data) {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  const offset = bytes.length >= GLOBAL_CONFIG_SIZE + ANCHOR_DISCRIMINATOR_SIZE ? ANCHOR_DISCRIMINATOR_SIZE : 0;

  if (bytes.length < offset + GLOBAL_CONFIG_SIZE) {
    throw new Error('Invalid global_config account size.');
  }

  let cursor = offset;

  const decoded = {
    admin: readPubkey(bytes, cursor),
  };
  cursor += 32;

  decoded.current_game_id = readU64(bytes, cursor);
  cursor += 8;

  decoded.active_game = readPubkey(bytes, cursor);
  cursor += 32;

  decoded.platform_fee_bps = readU16(bytes, cursor);
  cursor += 2;

  decoded.dump_fee_bps = readU16(bytes, cursor);
  cursor += 2;

  decoded.max_buy_lamports = readU64(bytes, cursor);
  cursor += 8;

  decoded.dump_trigger_lamports = readU64(bytes, cursor);
  cursor += 8;

  decoded.claim_window_secs = readI64(bytes, cursor);
  cursor += 8;

  decoded.paused = readBool(bytes, cursor);
  cursor += 1;

  decoded.default_minimum_live_time_secs = readI64(bytes, cursor);
  cursor += 8;

  decoded.default_graduation_target_lamports = readU64(bytes, cursor);
  cursor += 8;

  decoded.bump = readU8(bytes, cursor);

  return decoded;
}
